import {
  useEffect,
  useRef,
} from "react";

const WaypointReplacement = ({ node, onEnter, onLeave, children }) => {
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onEnter(node, true);
        } else {
          onLeave(node, false);
        }
      },
      {
        root: null, // Use `window` as scrollableAncestor
        rootMargin: "0px", // Can be configured if a delay is needed
        threshold: 0.1, // Visibility level of the element
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [node, onEnter, onLeave]);

  return (
    <div ref={sectionRef}>
      {children}
    </div>
  );
};

export default WaypointReplacement;
